import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import clsx from 'clsx';
import QuoteImages from '../QuoteImages';

const Item = ({ props }) => {
  const paramStyles = {
    IMAGE_LEFT: 'leftaligned',
    IMAGE_RIGHT: 'rightaligned',
    IMAGE_NONE: 'noimage',
  };

  const { params, fields } = props;
  const { author, heading, image, text } = fields;
  const { GridParameters, imageAlignment, textAlignment } = params;
  const shouldRenderImage =
    !!image?.value?.src && imageAlignment?.toLowerCase() !== paramStyles?.IMAGE_NONE;
  const shouldRenderHeading = !!heading?.value;

  let imageTextOrder = 'noImage';

  if (imageAlignment?.toLowerCase() === paramStyles?.IMAGE_LEFT) {
    imageTextOrder = 'imageOnLeft';
  }
  if (imageAlignment?.toLowerCase() === paramStyles?.IMAGE_RIGHT) {
    imageTextOrder = 'imageOnRight';
  }

  return (
    <div
      className={clsx(
        'section-quote',
        `${imageTextOrder}`,
        `textAlignment-${textAlignment}`,
        `${GridParameters !== undefined ? 'row' : ''}`
      )}
    >
      <div
        className={clsx(
          'flex-it auto-container',
          `${GridParameters !== undefined ? GridParameters : ''}`
        )}
      >
        {shouldRenderImage && (
          <div className={clsx('image-quote')}>
            <Image field={image} />
          </div>
        )}

        <div className={clsx('quote-title', shouldRenderHeading ? '' : 'onlyQuotes')}>
          <div className="header-quote">
            <div className="quotes-on-top">
              <QuoteImages />
            </div>
            {shouldRenderHeading && <RichText className="quote-heading" field={heading} />}
          </div>

          <RichText className="quote-text" field={text} />
          <RichText className="quote-author" field={author} />
        </div>
      </div>
    </div>
  );
};

export default Item;
